export const SETTLEMENT_PAYMENT_ENTITY_QUERY_LIMIT = 25;

export const SETTLEMENT_PAYMENT_REQUIRED_FIELDS = [
  "paymentAmount",
  "paymentDate",
  "paymentFrom",
  "paymentTo",
  "paymentType",
];
